module.exports = __webpack_public_path__ + "img/bespoke70_33.164deaca.jpg";